let stopListening = null;
let accessibilitySettingsResizeFrame = null;

function lockAccessibilitySettingsPosition() {
  const accessibilitySettings = document.querySelector('.accessibility-settings');

  if (!accessibilitySettings) {
    return;
  }

  accessibilitySettings.classList.remove('accessibility-settings--position-locked');

  const offsetParent = accessibilitySettings.offsetParent;
  if (!offsetParent) {
    return;
  }

  const offsetParentRect = offsetParent.getBoundingClientRect();
  const viewportWidth = document.documentElement.clientWidth;
  const viewportPadding = 10;
  const naturalLeft = offsetParentRect.left + accessibilitySettings.offsetLeft;
  const maxLeft = Math.max(
    viewportPadding,
    viewportWidth - accessibilitySettings.offsetWidth - viewportPadding
  );
  const left = Math.min(Math.max(naturalLeft, viewportPadding), maxLeft);
  const top = offsetParentRect.top + accessibilitySettings.offsetTop;

  accessibilitySettings.style.setProperty('--accessibility-settings-left', `${left}px`);
  accessibilitySettings.style.setProperty('--accessibility-settings-top', `${top}px`);
  accessibilitySettings.classList.add('accessibility-settings--position-locked');
}

function unlockAccessibilitySettingsPosition() {
  const accessibilitySettings = document.querySelector('.accessibility-settings');

  if (!accessibilitySettings) {
    return;
  }

  accessibilitySettings.classList.remove('accessibility-settings--position-locked');
  accessibilitySettings.style.removeProperty('--accessibility-settings-left');
  accessibilitySettings.style.removeProperty('--accessibility-settings-top');
}

function updateAccessibilityButtonState() {
  const accessibilityButton = document.querySelector('.header__button--accessibility');
  const fontSize = document.body.getAttribute('data-font-size');
  const isActive =
    document.body.getAttribute('data-accessibility') === 'true' ||
    document.body.getAttribute('data-no-images') === 'true' ||
    document.body.getAttribute('data-big-cursor') === 'true' ||
    Boolean(fontSize && fontSize !== 'normal');

  accessibilityButton?.classList.toggle('active', isActive);
  accessibilityButton?.setAttribute('aria-pressed', String(isActive));
}

function toggleAccessibilitySettings() {
  const accessibilitySettings = document.querySelector('.accessibility-settings');
  const accessibilityButton = document.querySelector('.header__button--accessibility');

  if (!accessibilitySettings) {
    return;
  }

  if (accessibilitySettings.classList.contains('active')) {
    closeAssibilitySettings();
    return;
  }

  accessibilitySettings.classList.add('active');
  accessibilityButton?.setAttribute('aria-expanded', 'true');
  lockAccessibilitySettingsPosition();

  if (!stopListening) {
    stopListening = clickOutside(
      accessibilitySettings,
      ['header__button--accessibility'],
      closeAssibilitySettings
    );
  }
}

function setAccessibilityMode(isActive) {
  const colorSchemeButton = document.querySelector('.accessibility-settings__button--wide');

  if (isActive) {
    document.body.setAttribute('data-accessibility', 'true');
  } else {
    document.body.removeAttribute('data-accessibility');
  }

  handleImageSwitch(isActive);
  colorSchemeButton?.classList.toggle('active', isActive);
  colorSchemeButton?.setAttribute('aria-pressed', String(isActive));
  updateAccessibilityButtonState();
}

function toggleAccessibilityMode() {
  const isActive = document.body.getAttribute('data-accessibility') === 'true';
  setAccessibilityMode(!isActive);
  saveState();
}

function closeAssibilitySettings() {
  document.querySelector('.accessibility-settings').classList.remove('active');
  unlockAccessibilitySettingsPosition();
  document.querySelector('.header__button--accessibility')?.setAttribute('aria-expanded', 'false');
  if (stopListening) {
    stopListening();
    stopListening = null;
  }
}

function onOffImagesFunc(type) {  
  if (type && !document.querySelector('.accessibility-settings__button[but-type="activate"]').classList.contains('active')) {
    document.querySelector('.accessibility-settings__button[but-type="activate"]').classList.add('active');
    document.querySelector('.accessibility-settings__button[but-type="disabled"]').classList.remove('active');
    document.body.setAttribute('data-no-images', false);
    
  }
  else if(!type && !document.querySelector('.accessibility-settings__button[but-type="disabled"]').classList.contains('active')) {
    document.querySelector('.accessibility-settings__button[but-type="disabled"]').classList.add('active');
    document.querySelector('.accessibility-settings__button[but-type="activate"]').classList.remove('active');
    document.body.setAttribute('data-no-images', true);
  }
  updateAccessibilityButtonState();
  saveState();
}

function handleImageSwitch(toBW) {
  const images = document.querySelectorAll('img[data-bw]');
  images.forEach(img => {
    if (toBW) {
      if (!img.dataset.original) {
        img.dataset.original = img.src;
      }
      img.src = img.dataset.bw;
    } else {
      if (img.dataset.original) {
        img.src = img.dataset.original;
        delete img.dataset.original;
      }
    }
  });
}

function setFontSize(doMore) {
  const levels = ['small', 'normal', 'large', 'xlarge'];
  let level = document.body.getAttribute('data-font-size');
  let index = levels.indexOf(level);
  index = index === -1 ? 1 : index; // Default to 'normal' if not set

  if ((doMore && index < levels.length-1) || (!doMore && index > 0)) {
    document.body.setAttribute('data-font-size', (doMore ? levels[index + 1] : levels[index - 1]));
    updateAccessibilityButtonState();
    saveState();
  }
}

function resetAll() {
  setAccessibilityMode(false);
  document.body.removeAttribute('data-no-images');
  document.querySelector('.accessibility-settings__button[but-type="disabled"]').classList.remove('active');
  document.querySelector('.accessibility-settings__button[but-type="activate"]').classList.add('active');
  document.body.removeAttribute('data-big-cursor');
  document.body.removeAttribute('data-font-size');
  updateAccessibilityButtonState();
  localStorage.removeItem('accessibilitySettings');
  closeAssibilitySettings();
}

function saveState() {
  const state = {
    accessibility: document.body.getAttribute('data-accessibility') === 'true',
    noImages: document.body.getAttribute('data-no-images') === 'true',
    bigCursor: document.body.getAttribute('data-big-cursor') === 'true',
    fontSize: document.body.getAttribute('data-font-size') || 'normal'
  };
  localStorage.setItem('accessibilitySettings', JSON.stringify(state));
}

function loadState() {
  const state = JSON.parse(localStorage.getItem('accessibilitySettings'));
  if (!state) {
    updateAccessibilityButtonState();
    return;
  }

  setAccessibilityMode(Boolean(state.accessibility));
  if (state.noImages){
    document.body.setAttribute('data-no-images', 'true');
    document.querySelector('.accessibility-settings__button[but-type="disabled"]').classList.add('active');
    document.querySelector('.accessibility-settings__button[but-type="activate"]').classList.remove('active');
  }
  if (state.bigCursor) document.body.setAttribute('data-big-cursor', 'true');
  if (state.fontSize) document.body.setAttribute('data-font-size', state.fontSize);
  updateAccessibilityButtonState();

}

function bindAccessibilityControls() {
  document.querySelector('.header__button--accessibility')
    ?.addEventListener('click', toggleAccessibilitySettings);
  document.querySelector('.accessibility-settings__button--wide')
    ?.addEventListener('click', toggleAccessibilityMode);
  document.querySelector('.accessibility-settings__button[but-type="activate"]')
    ?.addEventListener('click', () => onOffImagesFunc(true));
  document.querySelector('.accessibility-settings__button[but-type="disabled"]')
    ?.addEventListener('click', () => onOffImagesFunc(false));
  document.querySelector('[data-font-size-direction="decrease"]')
    ?.addEventListener('click', () => setFontSize(false));
  document.querySelector('[data-font-size-direction="increase"]')
    ?.addEventListener('click', () => setFontSize(true));
  document.querySelector('.accessibility-settings__reset')
    ?.addEventListener('click', resetAll);
}




window.addEventListener('resize', () => {
  const accessibilitySettings = document.querySelector('.accessibility-settings');

  if (!accessibilitySettings?.classList.contains('active') || accessibilitySettingsResizeFrame !== null) {
    return;
  }

  accessibilitySettingsResizeFrame = window.requestAnimationFrame(() => {
    accessibilitySettingsResizeFrame = null;
    lockAccessibilitySettingsPosition();
  });
});

bindAccessibilityControls();
loadState();
